<script lang="ts">
  import { createEventDispatcher } from 'svelte'
  import { defaultPaymentMethod } from '../store'
  import { CardBrand } from '../../elements'
  import { isPaymentSupported } from '../../helpers'

  export let error
  export let title = 'Payment'

  const dispatch = createEventDispatcher()

  function handleEdit() {
    dispatch('edit')
  }
</script>

<style>
  .payment-info {
    margin-top: 16px;
  }

  .title {
    margin-bottom: 8px;
    font-size: 20px;
    line-height: 28px;
    font-weight: 700;
  }

  .title {
    font-family: GT America;
    font-size: 15px;
    line-height: 18px;
    letter-spacing: 0;
    font-weight: bold;
    color: black;
    display: flex;
    align-items: center;
    height: 36px;
  }
  .content {
    width: 100%;
    height: 56px;
    border-radius: 5px;
    border: 1px solid #dee0e2;
    display: flex;
    justify-content: space-between;
  }

  .content .card {
    display: flex;
    align-items: center;
    padding-left: 16px;
  }

  .content .card .number {
    display: inline-block;
    margin-left: 16px;
  }

  .content button {
    background: white;
    border: none;
    color: #007bb3;
    font-size: 16px;
    line-height: 28px;
    padding: 8px 16px;
    margin: 0;
  }

  .content.error {
    border-color: #d83b41;
  }

  .content.null {
    border: none;
  }

  .content.null .card {
    color: #a8a8a8;
    padding: 0;
  }

  .error-msg {
    font-size: 11px;
    line-height: 15px;
    margin-top: 12px;
    color: #d83b41;
  }
</style>

<div class="payment-info">
  <p class="title">{title}</p>
  {#if $defaultPaymentMethod?.id}
    <div class="content" class:error={!!error}>
      <div class="card">
        <CardBrand brand={$defaultPaymentMethod.card.brand} />
        <span class="number" data-test="card-number">**** **** **** {$defaultPaymentMethod.card.last4}</span>
      </div>
      {#if isPaymentSupported($defaultPaymentMethod.provider)}
        <button data-cy="edit-payment" on:click={handleEdit}>Edit</button>
      {/if}
    </div>
    {#if error}
      <p class="error-msg">{error}</p>
    {/if}
  {:else}
    <div class="content null">
      <div class="card" data-cy="current-card">No card on file</div>
      <button data-cy="edit-payment" on:click={handleEdit}>Add</button>
    </div>
  {/if}
</div>
